import Axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiVersion = 'v1'

const axiosInstance = Axios.create({
  baseURL: `${BASE_URL}/${apiVersion}`,
});

export default axiosInstance;